"use client";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import SuccesSvg from "assets/svg/success.svg";

import { createSavedSearches } from "services/savedSearches";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Input from "components/common/input";
import CheckBoxItem from "components/common/checkbox-item";
import Button from "components/common/button";

import styles from "./styles.module.css";

const SaveSearchForm = ({ name, urlPath }) => {
  const [isDisable, setIsDisable] = useState(true);
  const [title, setTitle] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    setTitle(name);
    setIsDisable(name?.length < 0);
  }, []);

  const wrapperClass = classNames({
    [styles.wrapper]: true,
    [styles.wrapperHeight]: !isSuccess,
  });

  const handleInputChange = (value) => {
    if (value.length > 0) {
      setTitle(value);
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const getSuccessModal = () => {
    return (
      <div className={styles.successModal}>
        <SuccesSvg className={styles.successIcon} />
        <h4 className={styles.title}>Arama Kaydedildi</h4>
        <p className={styles.successInfo}>
          {isChecked
            ? `Kayıtlı aramana uygun yeni ilanlar olduğunda sana mail atacağız.`
            : `Aramana uygun ilanları mail olarak almak istersen, Kayıtlı Aramalarım sayfasından mail bildirimini açabilirsin.`}
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            href={`${window.env.EJ_APPS_PANEL_HOSTNAME}/#/kayitli-aramalarim`}
            blankTarget
            disable={isDisable}
            size={"M"}
          >
            Kayıtlı Aramalarıma Git
          </Button>
        </div>
      </div>
    );
  };

  const getForm = () => {
    return (
      <>
        <h4 className={styles.title}>Aramayı Kaydet</h4>
        <p className={styles.info}>
          Aramanı kaydettiğinde, seçtiğin filtrelere uygun yeni ilanları sana <b>e-posta</b> ile göndereceğiz.
        </p>
        <div className={styles.formWrapper}>
          <span className={styles.inputLabel}>Arama Adı</span>
          <div className={styles.adressNameInput}>
            <Input
              placeholder="Arama Başlığı Giriniz"
              errorMessage={errorMessage}
              onChange={(e) => handleInputChange(e.target.value)}
              onFocus={() => setErrorMessage("")}
              inputClass={styles.inputClass}
              defaultValue={name}
            />
          </div>
          <CheckBoxItem
            title={
              <span>
                Yeni ilanlar için <b>e-posta</b> gönder.
              </span>
            }
            name={"sendMail"}
            checkBoxClass={styles.checkboxClass}
            defaultChecked={true}
            onChange={(e) => handleCheckboxChange(e)}
          />
          <div className={styles.buttonWrapper}>
            <Button onClick={() => handleSendFormClick(urlPath)} disable={isDisable} size={"M"}>
              Aramayı Kaydet
            </Button>
          </div>
        </div>
      </>
    );
  };

  const handleSendFormClick = async (urlPath) => {
    try {
      const response = await createSavedSearches(isChecked, title, urlPath);
      if (response.status === "success") {
        setIsSuccess(true);
        Ga4WithEventParameters({
          eventName: "click_button",
          eventParameters: { label: "arama-kaydedildi" },
        });
      } else {
        const validateText = response?.data?.description?.tr;
        setErrorMessage(validateText);
      }
    } catch (error) {
      const validateText = error.response?.data?.description?.tr;
      setErrorMessage(validateText);
    }
  };
  return <div className={wrapperClass}>{isSuccess ? getSuccessModal() : getForm()}</div>;
};

SaveSearchForm.propTypes = {
  name: PropTypes.string,
  urlPath: PropTypes.string,
};

export default SaveSearchForm;
